import logo from './logo.svg';
import './App.css';
import React from 'react';
import MenuButton from './components/MenuButton';
import Window from './components/Window';
import TaskBar from './components/TaskBar';
import StartMenu from './components/StartMenu';
import AboutMeContent from './window_content/AboutMeContent';
import ProjectsContent from './window_content/ProjectsContent';
import ResumeContent from './window_content/ResumeContent';
import ContactContent from './window_content/ContactContent';
import CanvasContent from './window_content/CanvasContent';
//import VisualContent from './window_content/VisualContent';
import WebcamContent from './window_content/WebcamContent';
import {useState, useRef} from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { hideWindow, closeWindow } from './slices/mwSelectSlice';
//import WebcamContent from './window_content/WebcamContent';

const App = () =>{
  const startMenuVis = useSelector((state) => state.shower.startMenu);
  const menu1 = 'about-me'
  const menu2 = 'projects'
  const menu3 = 'resume'
  const menu4 = 'contact'
  const menu5 = 'canvas'
  const menu6 = 'webcam'
  
  

  return (
    <div>
      <div style={{
      display: 'flex',
      flexFlow: 'row',
      //position: 'relative',
      }}>
        <div style={{
          //zIndex: -5,
        }}>
          <h1 className='greet' >hi</h1>
          
          <MenuButton text={'About Me'} mbType={menu1+'-button'}/>
          <MenuButton text={'Projects'} mbType={menu2+'-button'}/>
          <MenuButton text={'Résumé'} mbType={menu3+'-button'}/>
          <MenuButton text={'Contact'} mbType={menu4+'-button'}/>
        </div>
        <div style={{
          width: window.innerWidth*.40,
          height: window.innerWidth*.40,
          backgroundImage: `url(${require('./img/twoofus.jpg')})`,
          backgroundSize: '50%',
          backgroundRepeat: 'no-repeat',
          zIndex: -500,
          marginLeft: '40%',
          marginTop: '3%',
        }}>
          <div style={{
            position: 'absolute',
            width: window.innerWidth*.20,
            height: window.innerWidth*.24,
            marginLeft: '25%',
            marginTop: '20%',
            backgroundImage: `url(${require('./img/shinji.png')})`,
            backgroundSize: '100%',
            backgroundRepeat: 'no-repeat',
          }}>

          </div>
        </div>
      </div>
      <Window mwType={menu1+'-window'} content={<AboutMeContent/>} allowResize={true} allowFS={true} baseWidth={900} baseHeight = {650}/>
      <Window mwType={menu2+'-window'} content={<ProjectsContent/>} allowResize={true} allowFS={true} baseWidth={900} baseHeight = {600}/>
      <Window mwType={menu3+'-window'} content={<ResumeContent/>} allowResize={true} allowFS={true} baseWidth={900} baseHeight = {650}/>
      <Window mwType={menu4+'-window'} content={<ContactContent/>} allowResize={false} allowFS={false} baseWidth={400} baseHeight = {250}/>
      <Window mwType={menu5+'-window'} content={<CanvasContent bodyWidth={900} allowFS={true} bodyHeight={600}/>} allowResize={false} baseWidth={900} baseHeight = {700}/>
      <Window mwType={menu6+'-window'} content={<WebcamContent/>} allowResize={false} allowFS={false} baseWidth={730} baseHeight = {580}/>
      <StartMenu></StartMenu>
      <TaskBar/>

    </div>
  )
}

export default App;
